/**
 *
 * ShareLink
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import copy from 'copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import useAlerts from 'containers/AlertService/useAlerts';
import shareUrl from 'utils/shareUrl';
import messages from './messages';
import { API2_ORIGIN } from '../../config/constants';

function ShareLink(props) {
  const { href, children, ...rest } = props;
  const { pathname } = useLocation();
  const addAlert = useAlerts();
  const url = href || `${API2_ORIGIN}${pathname}`;

  async function handleClick() {
    if (await shareUrl(url)) {
      return;
    }
    copy(url);
    addAlert({
      title: messages.copied,
      style: 'success',
      autoDismiss: true,
    });
  }

  const toggle = children || (
    <>
      <span className="hidden-xs">
        <FormattedMessage {...messages.share} />
      </span>
      <FontAwesomeIcon icon="share-alt" size="lg" fixedWidth />
    </>
  );
  return (
    <Button onClick={handleClick} {...rest}>
      {toggle}
    </Button>
  );
}

ShareLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  bsStyle: PropTypes.string,
};

ShareLink.defaultProps = {
  bsStyle: 'link',
};

export default ShareLink;
